import { useTranslation } from "react-i18next";

export default function ForgetPasswordCrumb(): string {
  const { t } = useTranslation();
  return t("crumb.ForgetPassword");
}
